import React from "react";
import { Table } from "react-bootstrap";

const CommonTable = ({ headers, rows, actions, type, noPadding, noScroll }) => {
    // noScroll → let the parent container handle overflow; useful inside
    // modals so we don't get a scrollbar-inside-a-scrollbar.
    const wrapClass = noScroll
        ? ''
        : (type === 'finding' ? '' : (rows?.length <= 6 ? 'max_content_height' : 'wrp_table'));

    return (
        <div
            className={wrapClass}
            style={{ padding: noPadding ? 0 : '0 20px' }}
        >
            <Table
                className="cstm_table"
                style={{
                    borderLeft: "1px solid #334155",
                    borderRight: "1px solid #334155",
                    borderBottom: "1px solid #334155",
                    borderRadius: '6px',
                    borderSpacing: 0,
                    borderCollapse: 'collapse'
                }} >
                <thead style={{ position: 'sticky', top: '0', zIndex: '9' }}>
                    <tr>
                        {headers?.map((header, index) => (
                            <th key={index} style={{ backgroundColor: "#1E293B", color: "#94A3B8", fontSize: "15px", fontWeight: "500", whiteSpace: "nowrap" }}>
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody
                >
                    {rows?.length === 0 ? (
                        <tr>
                            <td colSpan={headers?.length} style={{ textAlign: "center", backgroundColor: "#0F172A" }}>
                                <span className="color_white"> No data found</span>
                            </td>
                        </tr>
                    ) : (
                        rows?.map((row, index) => (
                            <tr key={index} style={{ backgroundColor: "#0F172A", ...(row?.rowStyle || {}) }}>
                                {row?.data.map((col, idx) => {
                                    // Handle skip flag for rowSpan cells
                                    if (col && typeof col === 'object' && col.skip) {
                                        return null;
                                    }

                                    // Handle rowSpan object
                                    if (col && typeof col === 'object' && col.rowSpan !== undefined) {
                                        return (
                                            <td
                                                className={`${type === 'finding' ? 'finding_cstm_table' : ''}`}
                                                key={idx}
                                                style={{ backgroundColor: "#0F172A", verticalAlign: 'middle', ...col.style }}
                                                rowSpan={col.rowSpan}
                                            >
                                                {col.value}
                                            </td>
                                        );
                                    }

                                    // Normal cell
                                    return (
                                        <td className={`${type === 'finding' ? 'finding_cstm_table' : ''}`} key={idx} style={{ backgroundColor: "#0F172A", verticalAlign: 'middle' }}>{col}</td>
                                    );
                                })}
                                {actions && (
                                    <td
                                        className={`${type === 'finding' ? 'finding_cstm_table' : ''}`}
                                        style={{ backgroundColor: "#0F172A", verticalAlign: 'middle', whiteSpace: 'nowrap' }}
                                    >
                                        {actions(row)}
                                    </td>
                                )}
                            </tr>
                        ))
                    )}
                </tbody>
            </Table >
        </div >
    );
};

export default CommonTable;
